module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_PT-a8f6c7c84b7d0d195fbbc6734244f435.svg";